export default __webpack_public_path__ + "static/media/construction-cleaning.93215a68.svg";